__webpack_require__.p = "/reports-clean/referrals-hub/";